export default {
  Comp1Title: {
    color: "#8C8C8C",
    fontWeight: "500",
    fontSize: "16px",
    opacity: 1,
    marginBottom: "1rem",
  },

  addMemberButton: {
    backgroundColor: "#043D90",
    width: "158px",
    height: "40px",
  },

  visitedContainer: {
    padding: "2.5rem 0px 1rem 0",
    margin: "16px 0",
  },
  title2: {
    paddingBottom: "12px",
    paddingTop: "12px",
    color: "#183053",
    textDecoration: "underline",
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: 32,
  },
  sec4heading: {
    color: "#5E5E5E",
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: 500,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
  },
  gridContainerOtherDeatils: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    rowGap: "28px",
  },
  gridItem: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  item: {
    flex: 1,
    display: "flex",
  },
  addMemberContainer: {
    width: "97%",
    columnGap: "2rem",
    margin: "2.5rem 0 1rem 0",
  },
  memberItem: {
    border: "none",
    padding: "10px 0 12px 20px",
    background: "#F6F6F6",
  },
  headerStyle: {
    backgroundColor: "white",
  },
  interviewBy: {
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    flex: 1,
    marginBottom: 16,
    backgroundColor: "#ECECEC",
    padding: "10px 20px 10px 20px",
  },

  interviewByQuestion: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    marginBottom: 16,
    paddingLeft: "20px",
  },

  preLabel: {
    maxWidth: "55%",
    flex: 1,
  },

  readOnlyInterviewBy: {
    maxWidth: "80%",
    border: "solid 1px",
    borderRadius: "4px",
    padding: "8px",
    borderColor: "rgba(0, 0, 0, 0.3",
    backgroundColor: "rgba(239, 239, 239, 1.5)",
    paddingRight: "20px",
  },

  interviewByNames: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#5e5e5e",
    cursor: "pointer",
  },
  returnReplacementContainer: {
    width: "97%",
    columnGap: "2rem",
  },
};
